export declare const server: (serv: Server) => void;
declare global {
    interface Server {
        /** Total number of ticks that have passed since the start of the world.
         * Best to use with modulo (e.g. Something every 10 seconds is `serv.tickCount % 20*10 === 0`)
         */
        'tickCount': number;
        /** Resets tick interval to occur `ticksPerSecond` times per second.
         *
         * Use {@link stopTickInterval `server.stopTickInterval()`} if you want but this method already calls that and you can use `serv.doDaylightCycle` to stop it anyway.
         */
        'setTickInterval': (ticksPerSecond: any) => void;
    }
}
